import clsx from 'clsx';
import { FilterTabOption } from 'components/CruiseSearchWidget/types';
import { useAppContext } from 'contexts/appContext';
import styles from './Tabs.css';

interface TabsProps {
	options: Array<FilterTabOption>;
	activeTab: FilterTabOption;
	onTabClicked: (option: FilterTabOption) => void;
}

const Tabs = ({ options, activeTab, onTabClicked }: TabsProps) => {
	const { dictionary } = useAppContext();

	return (
		<div className={styles.container}>
			{options.map((option) => {
				return (
					<button
						className={clsx(styles.tab, { [styles.selected]: activeTab?.value == option.value })}
						data-testid={option.testId}
						onClick={() => onTabClicked(option)}
						key={option.value}
					>
						{dictionary[option.dictionaryLabel]}
					</button>
				);
			})}
		</div>
	);
};

export { Tabs };
